<template>
  <div>
    <form class="form-horizontal">
      <h1 class="ts-py-3">{{ $t('homework.pageTitle') }}</h1>
      <div
        class="ts-border ts-rounded ts-border-blue-200 ts-border-opacity-20 ts-p-3"
      >
        <div class="row">
          <label class="ts-text-xs col-form-label col-md-4"
            >{{ $t('homework.date') }} :</label
          >
          <div class="col-md-8 text-left">
            <p class="mt-1">{{ resources.homework_date }}</p>
          </div>
        </div>
        <div class="row">
          <label class="ts-text-xs col-form-label col-md-4"
            >{{ $t('homework.class') }} :</label
          >
          <div class="col-md-8 text-left">
            <p class="mt-1">{{ resources.class_name }}</p>
          </div>
        </div>
        <div class="row">
          <label class="ts-text-xs col-form-label col-md-4"
            >{{ $t('homework.teacher') }} :</label
          >
          <div class="col-md-8 text-left">
            <p class="mt-1">{{ resources.teacher_name }}</p>
          </div>
        </div>
        <div class="row">
          <label class="ts-text-xs col-form-label col-md-4"
            >{{ $t('homework.subject') }} :</label
          >
          <div class="col-md-8 text-left">
            <p class="mt-1">{{ resources.subject_name }}</p>
          </div>
        </div>
        <div class="row">
          <label class="ts-text-xs col-form-label col-md-4"
            >{{ $t('homework.remark') }} :</label
          >
          <div class="col-md-8 text-left">
            <p class="mt-1">{{ resources.remarks }}</p>
          </div>
        </div>
      </div>
    </form>
    <private-comment
      v-if="student_homework_id"
      :studentHomeworkId="student_homework_id"
      maxHeight="45vh"
    />
  </div>
</template>
<script>
import PrivateComment from '../../private-comment/index'

export default {
  name: 'studentPrivateComment',
  props: ['resources'],
  components: {
    PrivateComment
  },
  data() {
    return {
      student_homework_id: null
    }
  },
  created() {
    this.student_homework_id = this.resources.student_homework[0].student_homework_id
  }
}
</script>
